module.exports = __webpack_public_path__ + "img/261086208.af976b76.jpg";